import React from 'react'

import type { Income } from 'renter/interfaces/api/income'
import { mapIncomeStreamVerificationMethodToType } from 'shared/utils/employmentAndIncome'

import EditPaystubModal from './EditStreamModals/EditPaystubModal'
import EditW2or1099Modal from './EditStreamModals/EditW2or1099Modal'

interface EditStreamDetailModalProps {
  stream: Income
  originalValues?: Partial<Income>
  submit: (values) => void
}

const EditStreamDetailModal = ({
  stream,
  originalValues,
  submit,
}: EditStreamDetailModalProps) => {
  const formType = mapIncomeStreamVerificationMethodToType(
    stream.incomeVerificationMethod,
    stream.source,
  )

  return (
    <>
      {formType == 'Paystub' && (
        <EditPaystubModal
          stream={stream}
          originalValues={originalValues}
          submit={submit}
        />
      )}
      {['1099', 'W2'].includes(formType) && (
        <EditW2or1099Modal
          stream={stream}
          originalValues={originalValues}
          submit={submit}
        />
      )}
    </>
  )
}

export default EditStreamDetailModal
